import styled from "@emotion/styled/macro";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Typography } from "@mui/material";
import { Theme } from "@mui/material/styles/createTheme";

export const UnreadDividerRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  margin: 2px 0;
  /* Keep the divider clear of the absolutely-positioned visibility banner when
     auto-scrolled into view, and leave a little context above it. */
  scroll-margin-top: 56px;
`;

export const UnreadDividerLine = styled(Box)`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => (theme as Theme).palette.primary.main};
  opacity: 0.35;
`;

export const UnreadDividerPill = styled(Box)`
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 16px;
  background: ${({ theme }) => (theme as Theme).palette.primary.main};
  color: ${({ theme }) => (theme as Theme).palette.primary.contrastText};
`;

export const UnreadDividerIcon = styled(KeyboardArrowDownIcon)`
  font-size: 16px;
`;

export const UnreadDividerLabel = styled(Typography)`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.02em;
  white-space: nowrap;
`;
